import React from "react";
import { Box } from "rebass/styled-components";
import styled from "styled-components";
import theme from "../../../theme/themeThree";
import "rc-slider/assets/index.css";
import "rc-tooltip/assets/bootstrap.css";
import Slider, { Handle } from "rc-slider";

const { createSliderWithTooltip } = Slider;
const Range = createSliderWithTooltip(Slider.Range);

const handle = (props) => {
  const { value, dragging, index, ...restProps } = props;
  return <Handle value={value} {...restProps} />;
};

const SliderContainer = styled(Box)`
  .rc-slider-tooltip-inner {
    background: ${(props) => props.theme.colors.ned};
  }

  .rc-slider-tooltip-arrow {
    display: none;
  }
`;

export function SliderSelect(props) {
  return (
    <SliderContainer
      {...props.padding}
      width={props.width}
      display={props.display}
    >
      {props.type === "range" ? (
        <Range
          min={props.min}
          max={props.max}
          step={props.step}
          value={props.value}
          trackStyle={[
            { backgroundColor: `${theme.colors.envy}` },
            { backgroundColor: `${theme.colors.envy}` },
          ]}
          handleStyle={[
            {
              width: 30,
              height: 30,
              boxShadow: "0px 4px 24px rgba(0, 0, 0, .2)",
              border: `1px solid ${theme.colors.ned}`,
              borderRadius: 8,
              backgroundColor: "white",
              marginTop: -14,
            },
            {
              width: 30,
              height: 30,
              boxShadow: "0px 4px 24px rgba(0, 0, 0, .2)",
              border: `1px solid ${theme.colors.ned}`,
              borderRadius: 8,
              backgroundColor: "white",
              marginTop: -14,
            },
          ]}
          railStyle={{ backgroundColor: `${theme.colors.chalkAlpha40}` }}
          onAfterChange={props.onAfterChange}
          onChange={props.onChange}
          defaultValue={[props.min, props.max]}
          tipFormatter={(value) => `${value}`}
        />
      ) : (
        <Slider
          min={props.min}
          max={props.max}
          value={props.value}
          step={props.step}
          handle={handle}
          onAfterChange={props.onAfterChange}
          onChange={props.onChange}
        />
      )}
    </SliderContainer>
  );
}
